const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJulia(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file_type_julia") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 8.309,
    cy: 22.592,
    r: 5.86,
    style: {
      fill: "#d5635c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.309,28.9a6.309,6.309,0,1,1,6.309-6.309A6.316,6.316,0,0,1,8.309,28.9Zm0-11.719a5.41,5.41,0,1,0,5.41,5.41A5.416,5.416,0,0,0,8.309,17.182Z",
    style: {
      fill: "#cb3c33"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 9.408,
    r: 5.86,
    style: {
      fill: "#60ad51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,15.717a6.309,6.309,0,1,1,6.309-6.309A6.316,6.316,0,0,1,16,15.717ZM16,4a5.41,5.41,0,1,0,5.41,5.41A5.416,5.416,0,0,0,16,4Z",
    style: {
      fill: "#389826"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.691,
    cy: 22.592,
    r: 5.86,
    style: {
      fill: "#aa79c1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.691,28.9A6.309,6.309,0,1,1,30,22.592,6.316,6.316,0,0,1,23.691,28.9Zm0-11.719a5.41,5.41,0,1,0,5.41,5.41A5.416,5.416,0,0,0,23.691,17.182Z",
    style: {
      fill: "#9558b2"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJulia);
export default __webpack_public_path__ + "static/media/Julia.9d778bc105e8ccaf420cf7d72967ffbc.svg";
export { ForwardRef as ReactComponent };